import { FC } from 'react';
import { useRouter } from 'next/router';
import NoSsr from '@common/noSsr';
import { FindStateType, LoginJoin, LoginForm, ModalStateType, SocialLogin } from '@components/loginModal';

import classnames from 'classnames/bind';
import styles from './login.module.scss';

const cx = classnames.bind(styles);

interface LoginProps {
  setModalState: (state: ModalStateType) => void;
  setFindState: (state: FindStateType) => void;
}

const Login: FC<LoginProps> = ({ setModalState, setFindState }) => {
  const router = useRouter();
  const { asPath } = router;

  return (
    <NoSsr>
      <div className={cx('wrap')}>
        <strong className={cx('title')}>
          <em className={cx('emphasis')}>잡다</em> 로그인하고 역검 튜토리얼 이용해 보세요
        </strong>
        <div className={cx('description')}>
          <span>잡다(JOBDA)에서는 무제한 튜토리얼 응시가 가능해요.</span>
          <span>[실전 응시]를 통해 결과표도 확인해 보세요.</span>
        </div>
        <div className={cx('formWrap')}>
          <LoginForm setFindState={setFindState} setModalState={setModalState} />
          <SocialLogin type={'PAGE'} redirectUrl={asPath} />
          <LoginJoin />
        </div>
      </div>
    </NoSsr>
  );
};

export default Login;
